import { render } from "./SalonHelp.vue?vue&type=template&id=6f394844"
import script from "./SalonHelp.vue?vue&type=script&lang=js"
export * from "./SalonHelp.vue?vue&type=script&lang=js"
script.render = render

export default script